<script>
import LOGOUT from '../graphql/Logout.gql'
import { onLogout } from '../vue-apollo'

export default {
  render: () => '',
  created() {
    this.$apollo
      .mutate({
        mutation: LOGOUT,
      })
      .then(() => {
        onLogout(this.$apollo.provider.clients.defaultClient).then(() => {
          this.$store
            .dispatch('user/clearProfile', this.$route.params.tenant)
            .then(() => {
              this.$router.push({
                name: 'Login',
                params: { tenant: this.$route.params.tenant },
              })
            })
        })
      })
      .catch(err => {
        console.dir(err)
      })
  },
}
</script>
